import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Radio,
  DatePicker,
  Button,
  message,
  Card,
  Upload,
} from "antd";
import axios from "axios";
import { UploadOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

function AttendanceForm() {
  const [form] = Form.useForm(); // 使用antd的Form Hooks
  const { Option } = Select;

  const [fileList, setFileList] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const handleUploadChange = (info) => {
    setFileList(info.fileList);
  };

  const handleSubmit = async (values) => {
    // 确保所有表单项都已填写（尤其是文件上传）

    setIsUploading(true);

    // 创建FormData对象以发送数据
    const formData = new FormData();

    fileList.forEach((file) => {
      formData.append("files", file.originFileObj); // 添加文件
    });

    // 添加其他表单数据
    formData.append("weChat", values.weChat);
    formData.append("phoneNumber", values.phoneNumber);
    formData.append("startDate", values.startDate.format("YYYY-MM-DD")); // 使用format格式化日期
    formData.append("endDate", values.endDate.format("YYYY-MM-DD"));
    formData.append("city", values.city);
    formData.append("large", values.large);
    formData.append("medium", values.medium);
    formData.append("small", values.small);
    formData.append("chemicals", values.chemicals);
    formData.append("pack", values.pack);
    formData.append("delivering", values.isDelivering);

    console.log(values);
    try {
      // 发送POST请求到后端API
      const response = await axios.post("/api/addRecord", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // 必须设置正确的Content-Type
        },
      });

      // 根据响应处理结果
      if (response.status === 200) {
        message.success("表单提交成功！");
        form.resetFields(); // 重置表单
        setFileList([]); // 清空文件列表
      } else {
        message.error("表单提交失败：" + response.data.message);
      }
    } catch (error) {
      console.error("提交异常：", error);
      message.error("表单提交异常");
    } finally {
      setIsUploading(false); // 更新上传状态
    }
  };

  return (
    <Form onFinish={handleSubmit} layout="vertical" className="form-container">
      <Card title="寄小帮行李寄存单" bordered={false}>
        <Form.Item
          name="weChat"
          label="微信 WeChat"
          rules={[{ required: true, message: "请输入微信号" }]}
        >
          <Input placeholder="请输入微信号" />
        </Form.Item>
        <Form.Item
          name="phoneNumber"
          label="电话号码 Phone Number"
          rules={[{ required: true, message: "请输入电话号码" }]}
        >
          <Input placeholder="请输入电话号码" />
        </Form.Item>
        <Form.Item
          name="startDate"
          label="开始日期 Start Date"
          rules={[{ required: true, message: "请选择开始日期" }]}
        >
          <DatePicker />
        </Form.Item>
        <Form.Item
          name="endDate"
          label="结束日期 End Date"
          rules={[{ required: true, message: "请选择结束日期" }]}
        >
          <DatePicker />
        </Form.Item>

        <Form.Item
          name="city"
          label="城市 City"
          rules={[{ required: true, message: "请选择城市" }]}
        >
          <Input placeholder="请输入城市" />
        </Form.Item>

        <Form.Item
          name="large"
          label="大包裹数量 Large Package Count"
          initialValue={0}
        >
          <Select placeholder="选择大包数量">
            {Array.from({ length: 11 }, (_, index) => {
              const value = index === 10 ? "10+" : index.toString();
              return (
                <Option key={index} value={value}>
                  {value}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item
          name="medium"
          label="中包裹数量 Medium Package Count"
          initialValue={0}
        >
          <Select placeholder="选择中包数量">
            {Array.from({ length: 11 }, (_, index) => {
              const value = index === 10 ? "10+" : index.toString();
              return (
                <Option key={index} value={value}>
                  {value}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item
          name="small"
          label="小包裹数量 Small Package Count"
          initialValue={0}
        >
          <Select placeholder="选择小包数量">
            {Array.from({ length: 11 }, (_, index) => {
              const value = index === 10 ? "10+" : index.toString();
              return (
                <Option key={index} value={value}>
                  {value}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item
          name="chemicals"
          label="行李中是否含有电池，易腐坏食品，危险化学品？"
          rules={[{ required: true, message: "请选择一个选项" }]}
        >
          <Radio.Group>
            <Radio value={true}>需要 Required</Radio>
            <Radio value={false}>不需要 Not Required</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="pack"
          label="是否需要上门行李打包服务？"
          rules={[{ required: true, message: "请选择一个选项" }]}
        >
          <Radio.Group>
            <Radio value={true}>需要 Required</Radio>
            <Radio value={false}>不需要 Not Required</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="isDelivering"
          label="是否需要取行李，送行李服务？"
          rules={[{ required: true, message: "请选择一个选项" }]}
        >
          <Radio.Group>
            <Radio value={true}>需要 Required</Radio>
            <Radio value={false}>不需要 Not Required</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="photo"
          label="照片/Photo"
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            if (Array.isArray(e)) {
              return e;
            }
            return e && e.fileList;
          }}
        >
          <Upload
            listType="picture"
            fileList={fileList}
            onChange={handleUploadChange}
            showUploadList={true}
            multiple
            beforeUpload={() => false} // Prevent automatic upload
          >
            <Button icon={<UploadOutlined />}>Select Files</Button>
          </Upload>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            提交 Submit
          </Button>
        </Form.Item>
      </Card>
    </Form>
  );
}

export default AttendanceForm;
